import React from 'react';
import PropTypes from 'prop-types';

const PaddleTotalWithTax = ({ subtotal, tax, total, coupon }) => {
  return (
    <div className="total-with-tax">
      {coupon && (
        <>
          <div className="total-with-tax__subtotal">
            <div className="total-with-tax__subtotal__label">Subtotal</div>
            <div className="total-with-tax__subtotal__value">${subtotal.toFixed(2)}</div>
          </div>
          <div className="total-with-tax__discount">
            <div className="total-with-tax__discount__label">{coupon.description}</div>
            <div className="total-with-tax__discount__value">-${coupon.amount.toFixed(2)}</div>
          </div>
        </>
      )}
      <div className="total-with-tax__tax">
        <div className="total-with-tax__tax__label">Sales Tax</div>
        <div className="total-with-tax__tax__value">${tax.toFixed(2)}</div>
      </div>
      <div className="total-with-tax__total">
        <div className="total-with-tax__total__label">Total</div>
        <div className="total-with-tax__total__value">
          <span className="total-with-tax__total__value__currency">USD$</span>
          <span className="total-with-tax__total__value__amount">{total.toFixed(2)}</span>
        </div>
      </div>
    </div>
  );
};

PaddleTotalWithTax.propTypes = {
  subtotal: PropTypes.number.isRequired,
  tax: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  coupon: PropTypes.shape({
    description: PropTypes.string.isRequired,
    amount: PropTypes.number.isRequired,
  }),
};

export default PaddleTotalWithTax;
